<div
  class="container-fluid m-0 p-5 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div class="text-center">
    <h2 class="font-pacifico">
      <span
        class="text-underline cursor-pointer"
        (click)="navigate('\achievements')"
        >Awards & Achievements</span
      >.
    </h2>
  </div>
  <p class="tagline font-raleway">
    I love to take part in Hackathons, Developer meetups, group discussions.
  </p>
  <p class="h6 text-center font-oxygen">
    Here are a few achievements and awards I've received:
  </p>

  <div class="d-flex flex-row justify-content-center">
    <div class="p-3">
      <div class="my-5" *ngFor="let obj of achievements; let i = index">
        <div class="h2 font-weight-bold font-raleway">{{ obj.title }}</div>
        <div class="d-flex flex-row">
          <div class="h5 font-weight-bold font-oxygen justify-content-start">
            {{ obj.subtitle }}
          </div>
          <div class="text-right font-weight-normal ml-auto">
            {{ obj.duration }}
          </div>
        </div>
        <ul class="list-group">
          <li
            class="list-group-item"
            [ngClass]="{
              'theme-light text-light border-light': themeService.flag
            }"
            *ngFor="let item of obj.description"
          >
            <span class="h5 font-raleway" [innerHTML]="item"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn mybtn depth m-3 mt-4"
      [ngClass]="{ 'mybtn-dark': themeService.flag }"
      (click)="navigate('\achievements')"
    >
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      <span class="h5 ml-2">Know More...</span>
    </button>
  </div>
</div>
